var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWtLogoGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 102,
    viewBox: "0 0 169 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_130_3529",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 169,
    height: 102
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.804 0.805878H131.989C124.444 0.805878 117.165 3.63119 111.557 8.73772L88.7871 29.4523C88.7871 29.4523 108.325 30.5536 109.284 45.7683C56.0571 56.3288 138.737 80.4324 138.737 80.4324C138.737 80.4324 138.413 38.7935 154.15 20.6551C154.526 20.2225 155.206 20.701 154.94 21.2123C142.784 44.0639 146.068 70.0489 146.068 70.0489L166.603 40.9502L166.849 35.9288L167.154 29.721L168.566 0.805878H154.804Z",
    fill: "#D71524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3286 38.0266C70.8988 24.3458 61.392 15.5814 55.8938 10.0226C50.0459 4.12287 42.1322 0.805916 33.8752 0.805916H21.0656C21.0656 0.805916 37.3593 11.4582 35.1316 14.5588C20.1589 -1.52119 0.0507812 0.805916 0.0507812 0.805916L2.11664 42.9889L30.5659 89.5639C30.5659 89.5639 33.532 45.3422 15.3278 18.0921C15.0428 17.6726 15.6386 17.2202 15.956 17.6136C38.2206 44.8899 37.6248 101.114 37.6248 101.114C37.6248 101.114 49.3465 101.711 63.3607 101.114C61.2042 86.1683 39.4381 55.4176 87.3221 38.0331L87.3286 38.0266Z",
    fill: "#D71524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.139 41.5533C39.78 62.5891 103.932 101.376 103.932 101.376H130.348C130.348 101.376 41.6646 67.4989 92.139 41.5533Z",
    fill: "#D71524"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_130_3529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20.3105,
    y: -15.4755,
    width: 200.481,
    height: 129.167,
    fill: "#D9D9D9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWtLogoGrey);
export default __webpack_public_path__ + "static/media/wt_logo_grey.64e866544f0b917b1a9d1967e0227fcf.svg";
export { ForwardRef as ReactComponent };